var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlmostThere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1152_12178)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1152_12178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#EEC141"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1152_12178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.9998H4.66667V5.33317L9.33333 0.666504L10.1667 1.49984C10.2444 1.57761 10.3084 1.68317 10.3587 1.8165C10.4084 1.94984 10.4333 2.07761 10.4333 2.19984V2.43317L9.7 5.33317H14C14.3556 5.33317 14.6667 5.4665 14.9333 5.73317C15.2 5.99984 15.3333 6.31095 15.3333 6.6665V7.99984C15.3333 8.07761 15.3222 8.16095 15.3 8.24984C15.2778 8.33873 15.2556 8.42206 15.2333 8.49984L13.2333 13.1998C13.1333 13.4221 12.9667 13.6109 12.7333 13.7665C12.5 13.9221 12.2556 13.9998 12 13.9998ZM6 12.6665H12L14 7.99984V6.6665H8L8.9 2.99984L6 5.89984V12.6665ZM4.66667 5.33317V6.6665H2.66667V12.6665H4.66667V13.9998H1.33333V5.33317H4.66667Z",
    fill: "#EEC141"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1152_12178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlmostThere);
export default __webpack_public_path__ + "static/media/almostThere.8f8d3e1cb8507c136e9d45f48c16b108.svg";
export { ForwardRef as ReactComponent };